import { useState, useEffect, useContext, useRef } from "react";
import { GlobalContext, HOST } from "./context/GlobalContext"
import { useDownloadExcel } from 'react-export-table-to-excel';

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import FloatingLabel from 'react-bootstrap/FloatingLabel'

import './App.css';
import { FileExcelFill } from "react-bootstrap-icons";


const CURRENCY_FORMAT = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
const DATE_FORMAT = new Intl.DateTimeFormat('es', { year: 'numeric', month: 'short', day: '2-digit', timeZone: (Intl.DateTimeFormat().resolvedOptions().timeZone) })

function Reportes() {
  const { setGlobalLoading, getReport, reportList, proveedoresList } = useContext(GlobalContext);

  const [ dateInit, setDateInit ] = useState( new Date() )
  const [ dateEnd, setDateEnd ] = useState( new Date() )
  const [ proveedor, setProveedor] = useState('')

  const tableRef = useRef(null);

  useEffect(() => {
    let today = new Date()
    setDateInit( today.toISOString().split('T')[0] )
    let tomorrow = new Date(today.getTime() + 86400000)
    setDateEnd( tomorrow.toISOString().split('T')[0] )
  }, []);

  const submitSearch = () => {
    getReport(dateInit, dateEnd, proveedor)
  }

  const { onDownload } = useDownloadExcel({
      currentTableRef: tableRef.current,
      filename: 'Reporte_libreria_' + DATE_FORMAT.format((new Date()).getTime()) ,
      sheet: 'Reporte'
  })

  return (
    <Container className='main-component'>
      <Container >
        <Row>
          <Col md={ 3 }>
            <Form.Group className='mb-3'>
              <FloatingLabel label="Proveedor Principal">
                <Form.Select required name="provPrincipal" value={ proveedor } onChange={ (e) => setProveedor( e.target.value ) }>
                  <option>Selecciona una opción</option>
                  { proveedoresList.map( item => (
                    <option key={ item.idProveedor } value={ item.idProveedor }>{ item.razonSocial }</option>
                  ))}
                </Form.Select>
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col md={ 3 }>
            <Form.Group className='mb-3'>
              <FloatingLabel label="Fecha de Inicio">
                <Form.Control type="date" defaultValue={ dateInit } value={ dateInit } onChange={ (e) => setDateInit( e.target.value ) } placeholder="" />
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col md={ 3 }>
            <Form.Group className='mb-3'>
              <FloatingLabel label="Fecha de Fin">
                <Form.Control type="date" value={ dateEnd } onChange={ (e) => setDateEnd( e.target.value ) } placeholder="" />
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col md={ 3 }>
            <button className="grl-btn" onClick={ () => submitSearch() }>{ 'Buscar' }</button>
          </Col>
        </Row>
        <Row>
          <div align="right">
            <div className="single-btn" style={{ width: 200 }} onClick={ onDownload } > <FileExcelFill />&nbsp;  Descargar Reporte </div>
          </div>
        </Row>
      </Container>
      <br/>
      <div style={{ overflowX: 'scroll' }}>
        <table ref={tableRef} className="report-table" >
          <tbody>
            <tr>
                <th>Código de Barras</th>
                <th>ID Producto</th>
                <th>Descripción</th>
                <th>Fecha Recepción</th>
                <th>ID Documento Recepción</th>
                <th>Remisión</th>
                <th>Monto Ingreso</th>

                <th>Cantidad Ingresados</th>
                <th>Cantidad de Venta por Título</th>
                <th>Devueltos</th>
                <th>Por Conciliar</th>

                <th>Folio de Venta</th>
                <th>Cantidad Venta x Folio</th>
                <th>Fecha de Venta</th>
                <th>PVP</th>
                <th>Desc. Público</th>
                <th>PVP con Desc. a Publico</th>
                <th>Monto de Ventas c/desc a Público</th>
                <th>Costo x ejemplar (% desc proveedor)</th>
                <th>Costo Total (Por cantidad de ventas)</th>
            </tr>
            { reportList.map( rem => {
              return rem.detalles.map( detalle => {
                let libro = detalle.ordenDetalle.libro;
                let entrada = rem.entradas.find( en => en.idRemisionDetalle === detalle.idRemisionDetalle )

                return <> 
                  <tr>
                    <td>{ libro.codigoIsbn.toString() }</td>
                    <td>{ libro.idLibro }</td>
                    <td>{ libro.titulo }</td>
                    <td>{ DATE_FORMAT.format(new Date(rem.fecha)) }</td>
                    <td></td>
                    <td>{ rem.idRemision }</td>
                    <td>{ CURRENCY_FORMAT.format(detalle.cantidad * detalle.ordenDetalle.costo) }</td>

                    <td>{ detalle.cantidad }</td>
                    <td>{ (entrada && entrada.ventaEntradas[0]) ? entrada.ventaEntradas[0].ventaDetalle.cantidad : 0 }</td>
                    <td>{ (entrada && entrada.devolucion) ? entrada.devolucion.cantidadDevuelta : 0 }</td>
                    <td>{ (entrada && entrada.devolucion) ? entrada.devolucion.cantidadLiquidar : 0 }</td>

                    { entrada.ventaEntradas.length === 0 && 
                      <>
                        <td/><td/><td/>
                        <td>{ CURRENCY_FORMAT.format(entrada.precio) }</td>
                        <td/><td/><td/>
                        <td>{ CURRENCY_FORMAT.format(detalle.ordenDetalle.costo) }</td>
                        <td/>
                      </>
                    } 
                  </tr>
                  { entrada.ventaEntradas.map((venta, idx) => (
                    <tr key={`venta-${idx}`}>
                      <td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/>
                      <td>{ venta.ventaDetalle.idVenta }</td>
                      <td>{ venta.ventaDetalle.cantidad }</td>
                      <td>{ DATE_FORMAT.format(new Date( venta.ventaDetalle.fecha)) }</td>
                      <td>{ CURRENCY_FORMAT.format(venta.ventaDetalle.precio) }</td>
                      <td>{ `${venta.ventaDetalle.descuento}%` }</td>
                      <td>{ CURRENCY_FORMAT.format(venta.ventaDetalle.monto / venta.ventaDetalle.cantidad) }</td>
                      <td>{ CURRENCY_FORMAT.format(venta.ventaDetalle.monto / venta.ventaDetalle.cantidad) }</td>
                      <td>{ CURRENCY_FORMAT.format(detalle.ordenDetalle.costo) }</td>
                      <td>{ CURRENCY_FORMAT.format(detalle.ordenDetalle.costo * venta.ventaDetalle.cantidad) }</td>

                      <td>{  }</td>
                    </tr>
                  ))}               
                </>
              })
            })}
            
          </tbody>
        </table>
      </div>

    </Container>
  );
}

export default Reportes;
